<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { RouterView } from 'vue-router'
import { request } from './services/api'
import { siteStatus } from './services/site-status'
import LegacyAlert from './components/LegacyAlert.vue'
import { moneySuccessMessage, closeMoneySuccess } from './services/money-success'

const ready = ref(false)
const checkError = ref('')
let timer
let checking = false
async function checkSite() {
  if (checking) return
  checking = true
  try {
    const result = await request('/config/detail', { anonymous: true, data: { name: 'web_site_close' } })
    siteStatus.closed = String(result.data) === '1'
    if (siteStatus.closed) {
      const reason = await request('/config/detail', { anonymous: true, data: { name: 'web_site_close_reason' } })
      siteStatus.reason = reason.data || '站点已经关闭，请稍后访问'
    }
    ready.value = true
    checkError.value = ''
  } catch (_) {
    if (siteStatus.closed) ready.value = true
    else checkError.value = '暂时无法连接网站，请稍后重试'
  } finally {
    checking = false
  }
}
function onVisibilityChange() {
  if (!document.hidden) checkSite()
}
onMounted(() => {
  checkSite()
  timer = window.setInterval(checkSite, 10000)
  document.addEventListener('visibilitychange', onVisibilityChange)
})
onUnmounted(() => {
  window.clearInterval(timer)
  document.removeEventListener('visibilitychange', onVisibilityChange)
})
</script>

<template>
  <main v-if="siteStatus.closed || !ready" class="site-status" role="status">
    <h1>{{ siteStatus.closed ? '网站暂时关闭' : '正在连接网站' }}</h1>
    <p>{{ siteStatus.closed ? siteStatus.reason : checkError || '请稍候…' }}</p>
    <button type="button" @click="checkSite">重新检查</button>
  </main>
  <RouterView v-else />
  <Teleport to="body">
    <LegacyAlert
      v-if="moneySuccessMessage"
      class="money-success-alert"
      header="提示"
      :message="moneySuccessMessage"
      :buttons="['确定']"
      @confirm="closeMoneySuccess"
      @cancel="closeMoneySuccess"
    />
  </Teleport>
</template>

<style scoped>
/* Legacy web/styles.*.css: Ionic md font and heading line-height. */
.money-success-alert { font-family:Roboto,"Helvetica Neue",sans-serif; }
.money-success-alert :deep(.alert-title) { line-height:1.2; }
.site-status { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px; box-sizing: border-box; text-align: center; background: #f7f8fa; color: #333; }
.site-status h1 { font-size: 22px; }
.site-status p { white-space: pre-wrap; overflow-wrap: anywhere; max-width: 100%; line-height: 1.7; }
.site-status button { margin-top: 16px; padding: 10px 24px; border: 0; border-radius: 6px; background: #ed4444; color: white; cursor: pointer; }
</style>
